import { toNumber, downloadBlob } from "@/shared/utils";

export type IsnaNumber = number | null;

export function num(value: string | number | null | undefined): IsnaNumber {
  if (value === null || value === undefined || value === "") return null;
  const parsed = toNumber(value);
  if (!Number.isFinite(parsed) || parsed === 0) return null;
  return parsed;
}

export function sumNums(...values: Array<string | number | null | undefined>): IsnaNumber {
  let acc = 0;
  let hasValue = false;
  for (const value of values) {
    const parsed = num(value);
    if (parsed !== null) {
      acc += parsed;
      hasValue = true;
    }
  }
  return hasValue ? acc : null;
}

export interface QuarterColumn {
  I: IsnaNumber;
  II: IsnaNumber;
  III: IsnaNumber;
  total: IsnaNumber;
}

export function quarterColumn(
  month1: string | number | null | undefined,
  month2: string | number | null | undefined,
  month3: string | number | null | undefined,
  total: string | number | null | undefined,
): QuarterColumn {
  return { I: num(month1), II: num(month2), III: num(month3), total: num(total) };
}

export function emptyQuarterColumn(): QuarterColumn {
  return { I: null, II: null, III: null, total: null };
}

export interface MonthTriad {
  I: IsnaNumber;
  II: IsnaNumber;
  III: IsnaNumber;
}

export function emptyMonthTriad(): MonthTriad {
  return { I: null, II: null, III: null };
}

export interface ProvisionEntry {
  desc: string | null;
  number: IsnaNumber;
}

export interface ProvisionTable {
  total_desc: string | null;
  total_number: IsnaNumber;
  table: never[];
}

export function provisionEntry(value?: string | number | null): ProvisionEntry {
  return { desc: null, number: num(value) };
}

export function provisionTable(): ProvisionTable {
  return { total_desc: null, total_number: null, table: [] };
}

export function padRowNumber(rowNumber: number): string {
  return String(rowNumber).padStart(8, "0");
}

export function formatDeclarationDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function downloadJson(data: unknown, filename: string): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  downloadBlob(blob, filename);
}
